// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('usergroupSetting', {
//         templateUrl: 'views/components/views/usergroupSetting/usergroupSetting.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'modalService', 'translateService', 'usergroupSettingService', 'layoutService', function ($stateParams, modalService, translateService, usergroupSettingService, layoutService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let itemId = $stateParams.item_id;

//             let translations = {
//                 confirm_title: '',
//                 confirm_switch_off_all_message: '',
//                 confirm_ok_label: '',
//                 confirm_cancel_label: '',
//                 error: '',
//                 ok: ''
//             };

//             vm.model = {
//                 tabletSize: layoutService.getMediaQueries().tablet,
//                 videoUrlButtons: [
//                     { id: 'goto', icon: 'fa fa-solid fa-window-restore', color: 'primary', type: 'primary', onClick: () => window.open(vm.model.setting.video_url) }
//                 ],
//                 itemState: '',
//                 itemId: '',
//                 setting: {},
//                 itemsListUserGroupSettings: [],
//                 showEnableButton: false,
//                 showDisableButton: false,
//                 lockedEnable: false,
//                 lockedDisable: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATION FUNCTION

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATION FUNCTION

//             // #region LOAD PROCEDURE FUNCTIONS

//             async function loadSetting() {
//                 vm.model.setting = (await usergroupSettingService.getSetting({ p2_setting_keyno: itemId }))[0];
//             }

//             async function loadUserGroupSettings() {
//                 vm.model.itemsListUserGroupSettings = await usergroupSettingService.listUserGroupSettings({ p2_setting_keyno: itemId });

//                 vm.model.itemsListUserGroupSettings.forEach((item) => {
//                     if (item.item_glyphicon === 'glyphicon-check') {
//                         vm.model.showEnableButton = false;
//                         vm.model.showDisableButton = true;
//                     } else {
//                         vm.model.showEnableButton = true;
//                         vm.model.showDisableButton = false;
//                     }
//                 });

//                 vm.model.itemsListUserGroupSettings.forEach((item) => {
//                     if (item.item_state > '') {
//                         vm.model.itemState = item.item_state;
//                     }
//                 });
//             }

//             // #endregion LOAD PROCEDURE FUNCTIONS

//             // #region UPDATE PROCEDURE LIST FUNCTION

//             vm.updateList = function () {
//                 vm.model.itemId = '';
//                 loadUserGroupSettings();
//             };

//             // #endregion UPDATE PROCEDURE LIST FUNCTION

//             // #region LIST DIRECTION BUTTON FUNCTION

//             vm.openEdit = function (item) {
//                 vm.model.itemId = item.item_id;
//             };

//             // #endregion LIST DIRECTION BUTTON FUNCTION

//             // #region ENABLE ALL BUTTON FUNCTION
            
//             vm.enableAll = function () {
//                 vm.model.lockedEnable = true;
//                 vm.model.itemId = '';
    
//                 usergroupSettingService.changeAllItems({
//                     p2_setting_keyno: itemId,
//                     onoff: '1'
//                 }).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                         modalService.show({
//                             type: 'warning',
//                             title: translations.error,
//                             message: response[0].errormessage,
//                             buttons: [{
//                                 label: translations.ok,
//                                 cssClass: 'btn-warning',
//                                 action: function (dialogItself) {
//                                     dialogItself.close();
//                                     vm.model.lockedEnable = false;
//                                 }
//                             }]
//                         });
//                     } else {
//                         vm.model.lockedEnable = false;
//                         vm.model.showEnableButton = false;
//                         vm.model.showDisableButton = true;

//                         loadUserGroupSettings();
//                     }
//                 });
//             };

//             // #endregion ENABLE ALL BUTTON FUNCTION

//             // #region DISABLE ALL BUTTON FUNCTION
            
//             vm.disableAll = function () {
//                 vm.model.lockedDisable = true;
//                 vm.model.itemId = '';
                
//                 modalService.confirm({
//                     type: 'danger',
//                     title: translations.confirm_title,
//                     message: translations.confirm_switch_off_all_message,
//                     okLabel: translations.confirm_ok_label,
//                     cancelLabel: translations.confirm_cancel_label
//                 }).then(function () {
//                     usergroupSettingService.changeAllItems({
//                         p2_setting_keyno: itemId,
//                         onoff: '0'
//                     }).then(function (response) {
//                         if (response[0].errorcode !== '0') {
//                             modalService.show({
//                                 type: 'warning',
//                                 title: translations.error,
//                                 message: response[0].errormessage,
//                                 buttons: [{
//                                     label: translations.ok,
//                                     cssClass: 'btn-warning',
//                                     action: function (dialogItself) {
//                                         dialogItself.close();
//                                         vm.model.lockedDisable = false;
//                                     }
//                                 }]
//                             });
//                         } else {
//                             vm.model.lockedDisable = false;
//                             vm.model.showEnableButton = true;
//                             vm.model.showDisableButton = false;

//                             loadUserGroupSettings();
//                         }
//                     }, function () {
//                         vm.model.lockedDisable = false;
//                     });
//                 }, function () {
//                     vm.model.lockedDisable = false;
//                 });
//             };

//             // #endregion DISABLE ALL BUTTON FUNCTION

//             // #region ON INIT FUNCTION

//             vm.$onInit = function () {
//                 translate();
//                 loadSetting();
//                 loadUserGroupSettings();
//             };

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
